import usePaginatedData from './use-paginated-data';
import { APIApartmentItem, APIRequestStatus } from 'api/types';

export type APIRequestItem = {
  id: number;
  title: string;
  createdAtDate: string;
  status: APIRequestStatus;
  facility: APIApartmentItem;
};

export type APIRequestsRes = {
  items: APIRequestItem[];
  count: number;
};

const useRequests = () => {
  const result = usePaginatedData<APIRequestsRes, APIRequestItem>('/deal-requests', 'get');

  return result;
};

export default useRequests;
